import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import { useUniqueID } from "@xo-union/react-unique-id";
import { IconButton } from "@xo-union/tk-component-icons";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "./styles.css";
const Snackbar = _ref => {
  let {
    children,
    visible,
    fixedToRelative,
    onClose,
    classes: classesProp,
    id: idProp,
    ...props
  } = _ref;
  const id = useUniqueID(idProp);
  const classes = useClasses(styles, classesProp);
  const visibility = visible ? 'is-visible' : `is-not-visible`;
  const visibleClass = classes[visibility];
  const dialogRole = visible ? 'alertdialog' : 'none';
  const role = visible ? 'alert' : 'none';
  const live = visible ? 'assertive' : 'off';
  const ariaHidden = !visible;
  const positionClass = fixedToRelative ? classes['fixed-to-relative'] : classes['fixed-to-page'];
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes['snackbar-wrapper']} ${positionClass}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.container} ${visibleClass}`,
    role: dialogRole,
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React.createElement("div", {
    className: classes['close-button-container']
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose,
    "aria-label": "Dismiss",
    "aria-controls": id,
    name: "close",
    size: "md"
  })), /*#__PURE__*/React.createElement("div", _extends({
    role: role,
    "aria-live": live,
    id: id,
    className: classes.children
  }, props), children)));
};
Snackbar.defaultProps = {
  fixedToRelative: false,
  visible: false
};
process.env.NODE_ENV !== "production" ? Snackbar.propTypes = {
  /**
   * Contents of snackbar
   */
  children: PropTypes.node,
  /**
   * Should the snackbar be visible
   */
  visible: PropTypes.bool,
  /**
   * Whether or not to position the snackbar within a relative.
   * This use is discouraged except for a few scenarios like the sidebar. This
   * is only supported if the parent container is at the bottom of the viewport.
   */
  fixedToRelative: PropTypes.bool,
  /**
   * Called when the close button is clicked
   */
  onClose: PropTypes.func,
  /**
   * Class dependencies
   */
  classes: classesPropType(['children', 'close-button-container', 'container', 'fixed-to-relative', 'fixed-to-page', 'is-visible', 'is-not-visible', 'snackbar-wrapper']),
  /**
   * ID of the snackbar component
   */
  id: PropTypes.string
} : void 0;
export default Snackbar;